import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScrimbaComponent } from './simple-icons-scrimba.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScrimbaComponent ],
    exports:      [ SimpleIconsScrimbaComponent ],
    bootstrap:    []
})
export class SimpleIconsScrimbaModule {}
